export default "__VITE_ASSET__COsEg8pD__"